import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import LandingPage from '#/domains/landing/pages/LandingPage';
import BenefitDetailRedirect from '#/domains/landing/pages/BenefitDetailRedirect';
import BenefitsPreviewPage from '#/domains/preview/pages/BenefitsPreviewPage';
import { getRuntimeBase } from '#/utils/runtimeBase';

/**
 * Router shell for the gov-benefit service.
 * - "/" renders the existing 혜택알리미 promo (App)
 * - "/benefit/:serviceSeqNo" redirects to the external benefit detail page
 * - Catch-all "*" renders a landing page from public/{slug}/landing-page.json
 */
function AppRouter() {
  const basename = getRuntimeBase().replace(/\/$/, '') || undefined;

  return (
    <BrowserRouter {...(basename ? { basename } : {})}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/benefits-preview" element={<BenefitsPreviewPage />} />
        <Route
          path="/benefit/:serviceSeqNo"
          element={<BenefitDetailRedirect />}
        />
        <Route path="*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AppRouter;
